export const handleValidateYardForm = ({
  yardFormData,
  multiSelectItems,
  getError,
  setIsFormValid,
  setErrors,
  isHandleSave,
}) => {
  const notRequiredFields = ['contactName', 'contactNumber', 'secure'];
  // Only requeued fields
  const yardFormDataFields = Object.entries(yardFormData).filter(
    (yardFordField) => !notRequiredFields.includes(yardFordField[0]),
  );
  const errors = {};
  for (const yardFormDataField of yardFormDataFields) {
    if (!yardFormDataField[1]) {
      errors[yardFormDataField[0]] = getError(yardFormDataField[0]);
    }
  }
  if (!multiSelectItems.length) {
    errors.vendor = getError('vendor');
  }
  const isFormValidWhenSaving = !Object.keys(errors).length && isHandleSave;
  if (isFormValidWhenSaving) {
    setIsFormValid(true);
  }
  setErrors(errors);
};

export const parseValidationError = (errors) => {
  const validationErrorsObject =
    errors[0]?.graphQLErrors?.[0]?.extensions?.exception?.validationErrors?.[0]
      ?.constraints || {};
  const validationErrorsMessages = Object.values(validationErrorsObject);
  let validationErrorsJoinMessage = '';
  if (validationErrorsMessages.length) {
    validationErrorsJoinMessage = validationErrorsMessages.join('; ');
  }
  return validationErrorsJoinMessage;
};
